import { action, computed, observable, toJS, autorun } from "mobx";
import { store } from "@store";
import { TodoSearchItemFragment, TodoBadges, NodeRef, TodoCategory } from "@graphql";
import { SnackbarStore } from "../SnackbarStore";
import { BaseStore } from "../BaseStore";
import { UserStore } from "../UserStore/UserStore";
import { UIStore } from "../UIStore";

/**
 * Ticket service sunset (CRMDEV-7103): tickets are readonly. Quick-add and
 * the live badge subscription are gone — badges are served zeroed from the
 * profile and only drive team selection / category filtering.
 */
export class TodoStore extends BaseStore {
  @observable badges: TodoBadges = null;
  @observable selectedTeam: NodeRef = null;
  private todoSearchStore = null;
  private userStore;

  @observable private activeCategory: (
    completed: boolean,
    deleted: boolean,
    all: boolean
  ) => TodoSearchItemFragment[] = null;

  constructor(
    private snackbars: SnackbarStore,
    private user: UserStore,
    private ui: UIStore
  ) {
    super();
    this.userStore = user;

    autorun(() => {
      if (
        user.myProfile &&
        !this.selectedTeam &&
        user.myProfile.todoBadges?.TeamBadges[0]
      ) {
        this.selectedTeam = user.myProfile.favoriteTeam
          ? user.myProfile.todoBadges.TeamBadges.find(
              (x) => x.TeamRef.Name === user.myProfile.favoriteTeam
            )?.TeamRef
          : user.myProfile.todoBadges.TeamBadges[0].TeamRef;
        this.setBadges(user.myProfile.todoBadges.TeamBadges[0]);
      }
    });
  }

  setTodoSearchStore(_todoSearchStore) {
    this.todoSearchStore = _todoSearchStore;
  }

  @action.bound setBadges(data: TodoBadges) {
    this.badges = data;
  }

  @action.bound setTeam(teamId: string) {
    if (this.userStore.myProfile) {
      const data = this.userStore.myProfile.todoBadges.TeamBadges.find((x) => {
        if (teamId === x.TeamRef.NodeID) {
          return x;
        }
      });
      this.selectedTeam = data.TeamRef;
      this.setBadges(data);

      if (this.todoSearchStore && this.todoSearchStore.filterManager) {
        this.todoSearchStore.filterManager.updateFilter({
          teamIds: [teamId],
          category: [TodoCategory.MyTask]
        });
      }
    }
  }

  @computed get teamsForTodo() {
    const teams = toJS(store().cache.teams).map((x) => ({
      label: x.Name,
      value: `${x.TodoGroup}`
    }));

    return teams.filter((x) => x.value !== "Staffing");
  }
}
